import type {WixCodeFileDescriptor} from '@wix/document-services-types'
import _ from 'lodash'
import systemFolders from './systemFolders'

function isFileSystemItem(fileSystemItem: WixCodeFileDescriptor): boolean {
    // @ts-expect-error
    return _.isObject(fileSystemItem) && fileSystemItem.name && fileSystemItem.location
}

function isFolder(fileSystemItem: WixCodeFileDescriptor): boolean {
    return isFileSystemItem(fileSystemItem) && fileSystemItem.directory
}

function isFile(fileSystemItem: WixCodeFileDescriptor): boolean {
    return isFileSystemItem(fileSystemItem) && !fileSystemItem.directory
}

function isInsideFolder(folder: WixCodeFileDescriptor, item: WixCodeFileDescriptor): boolean {
    return isFolder(folder) && item.location.indexOf(folder.location) === 0
}

function getFileName(file: WixCodeFileDescriptor): string {
    return _.last(file.location.split('/'))
}

function getParentFolderPath(item: WixCodeFileDescriptor) {
    const path = item.location

    const parts = path
        .replace(/\/$/, '') // remove trailing slash in case of folder
        .split('/')

    parts.pop() // remove item name
    return parts.join('/')
}

function isPagesFolder(descriptor: WixCodeFileDescriptor) {
    return isFolder(descriptor) && _.startsWith(descriptor.location, systemFolders.PAGES)
}

function isPageFile(descriptor: WixCodeFileDescriptor) {
    return (
        isFile(descriptor) &&
        descriptor.location.split('/').length === 3 &&
        _.startsWith(descriptor.location, systemFolders.PAGES)
    )
}

function isGlobalCssFile(descriptor: WixCodeFileDescriptor) {
    return (
        isFile(descriptor) &&
        (_.isEqual(descriptor.location, `${systemFolders.STYLES}/global.css`) ||
            _.isEqual(descriptor.location, `${systemFolders.STYLES}/widget.css`))
    )
}

function isSystemFolder(descriptor: WixCodeFileDescriptor) {
    return (
        isFolder(descriptor) &&
        _.includes(_.values(systemFolders), descriptor.location.toLowerCase().replace(/\/*$/, ''))
    )
}

function getPageId(descriptor: WixCodeFileDescriptor) {
    if (isPageFile(descriptor)) {
        return getFileName(descriptor).replace('.js', '')
    }
}

export default {
    isFileSystemItem,
    isFolder,
    isFile,
    isInsideFolder,
    getFileName,
    isPagesFolder,
    isPageFile,
    isGlobalCssFile,
    isSystemFolder,
    getParentFolderPath,
    getPageId
}
